import React, { useEffect, useMemo, useState } from 'react';

function getPlatform() {
  if (typeof navigator === 'undefined') return 'desktop';
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) return 'ios';
  if (/android/.test(ua)) return 'android';
  return 'desktop';
}

function detectBrowser() {
  if (typeof navigator === 'undefined') return 'other';
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('edg/')) return 'edge';
  if (ua.includes('chrome/')) return 'chrome';
  if (ua.includes('safari/') && !ua.includes('chrome/')) return 'safari';
  return 'other';
}

function isStandalone() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

function getInstallHelp(platform, browser) {
  if (platform === 'ios') {
    return 'En iPhone/iPad: tocá Compartir y luego Agregar a pantalla de inicio.';
  }
  if (browser === 'chrome') {
    return 'En Chrome: menú ⋮ -> Instalar app.';
  }
  if (browser === 'edge') {
    return 'En Edge: menú ... -> Aplicaciones -> Instalar este sitio como una aplicación.';
  }
  if (platform === 'android') {
    return 'En Android: menú del navegador -> Agregar a pantalla de inicio o Instalar app.';
  }
  return 'Usá el menú del navegador para instalar la app en este dispositivo.';
}

function InstallPrompt() {
  const platform = useMemo(() => getPlatform(), []);
  const browser = useMemo(() => detectBrowser(), []);

  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [installed, setInstalled] = useState(() => {
    if (typeof window === 'undefined') return false;
    return isStandalone() || localStorage.getItem('pwa_installed') === 'true';
  });
  const [manualHint, setManualHint] = useState('');

  const buttonLabel = useMemo(() => {
    if (installed) return 'Abrir app';
    if (platform === 'ios') return 'Agregar a inicio';
    return 'Instalar app';
  }, [installed, platform]);

  useEffect(() => {
    const onBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setManualHint('');
    };

    const onAppInstalled = () => {
      setInstalled(true);
      localStorage.setItem('pwa_installed', 'true');
      setDeferredPrompt(null);
      setManualHint('');
    };

    window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt);
    window.addEventListener('appinstalled', onAppInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstallPrompt);
      window.removeEventListener('appinstalled', onAppInstalled);
    };
  }, []);

  const handleClick = async () => {
    if (installed) {
      window.location.href = '/';
      return;
    }

    if (platform === 'ios') {
      setManualHint(getInstallHelp(platform, browser));
      return;
    }

    if (!deferredPrompt) {
      setManualHint(getInstallHelp(platform, browser));
      return;
    }

    deferredPrompt.prompt();
    const choice = await deferredPrompt.userChoice;
    if (choice?.outcome === 'accepted') {
      localStorage.setItem('pwa_installed', 'true');
      setInstalled(true);
    }
    setDeferredPrompt(null);
    setManualHint('');
  };

  return (
    <div className="install-prompt">
      <button className={`install-btn ${installed ? 'open-btn' : ''}`} onClick={handleClick}>
        {buttonLabel}
      </button>
      {manualHint ? <p className="install-hint">{manualHint}</p> : null}
    </div>
  );
}

export default InstallPrompt;
